@if (ratingControls()) {
  <div
    class="rating-buttons d-flex gap-2 flex-wrap"
    [class.m-auto]="marginAuto()"
    [class.flex-column]="isButtonTemplate()"
  >
    <!--    @if (showRatingNumber()) {-->
    <!--      <span class="item-rating-numbers bg-dark-blue text-white px-2">{{-->
    <!--        Math.abs(qualification())-->
    <!--      }}</span>-->
    <!--    }-->
    <div
      class="rating-buttons d-flex justify-content-md-center justify-content-start flex-wrap gap-1"
      [class.m-auto]="marginAuto()"
      (mouseleave)="clearHoveredRating()"
    >
      @for (rating of ratingControls(); track $index) {
        <label
          class="radio-group mb-0"
          [class.gray]="gray()"
          (mouseenter)="setHoveredRating($index + 1)"
        >
          <input
            [name]="randomStrings()[$index] + $index"
            [value]="$index + 1"
            (click)="!disabled() ? setRating($index + 1) : $event.preventDefault()"
            [formControl]="toFormControl(rating)"
            type="radio"
          />
          <span
            class="checkmark"
            [class.checkmark--active]="(hoveredRating() || Math.abs(qualification())) >= $index + 1"
            [style.width]="size()"
            [style.height]="size()"
            [style.fontSize]="size()"
          >
            <i class="inm-icon-star" aria-hidden="true"></i>
          </span>
        </label>
      }
    </div>
    <ng-template *ngTemplateOutlet="buttonTemplate()"></ng-template>
  </div>
}
